import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { useOperationsListPage } from '../context/OperationsListPageContext';

const OperationsTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationsListPage();

  const hasOptions = data.isAdmin && !data.isReadOnly;

  const columns = [
    {
      key: 'operation',
      content: t('Operation'),
    },
    {
      key: 'comments',
      content: t('Comments'),
      hideOnMobile: true,
    },
    {
      key: 'date',
      content: t('Date'),
      textPosition: 'center',
    },
    {
      key: 'shares',
      content: t('NrPart'),
      textPosition: 'right',
    },
    {
      key: 'amount',
      content: t('Amount'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    hasOptions ? { key: 'actions', content: '', textPosition: 'left' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default OperationsTableHeader;
